import React from 'react';
import Img from "../../images/services/bd/custom.png";
import {Container, Row, Col} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Buildpurpose(props) {
    return (
        <div className="services_orange_bg p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto text-center order-2 order-md-1">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="services_title my-auto order-1 order-md-2">
                        <h2>User-Centric Beacon Development</h2>
                        <p>BLE apps transmit low-energy signals and open versatile opportunities for businesses to
                            connect with their audience. These connected devices allow businesses remote, real-time
                            access to unprecedented data, build onto it and deliver exceptional consumer experience.</p>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Buildpurpose;